import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[safeSourceContent]',
    standalone: true
})
export class SafeSourceContentDirective implements AfterViewInit  {
    @Input('safeSourceContent') _safeSourceContent: string;

    constructor(private elem: ElementRef<HTMLObjectElement>) {}

    ngAfterViewInit() {
        // silenciando o Sonar: não pode usar bypassSecurityTrust*() mesmo se eu controlar/gerar o conteúdo na aplicação (o que é um absurdo)
        this.elem.nativeElement.data = this._safeSourceContent;
    }
}
